import Vue from "vue";

let _vm = new Vue();
const BASEURL = "/boss";
const DSPURL = "/dsp";
const FREPORT = "/flow-report"
const VERSION = "/v2";

/**** CAS登录相关 ****/
// export const loginRsaCas = p => _vm.fetch('/cas/rsa', p)
// export const loginParams = serviceUrl => _vm.fetch('/cas/login', { fetchExecution: true, service: serviceUrl || ''}, 'HTML')

/**** BOSS模块 ****/
// 基础资料-全量行政区域树
export const fullDistTree = () => _vm.fetch(BASEURL + '/bp/v2/queryFullDistTreeForPE', {level:1, guid: 1}, 'GET')

// 异步区域树通用接口 - 获取树形数据
export const districtTreeAsync = p =>
  _vm.fetch(
    BASEURL + "/deviceDistrict/v2/device-districts-info/tree-structure",
    p,
    "GET"
  );

// 异步区域树通用接口 - 搜索区域 keyWord-搜索关键字 searchRange-搜索的最小区域层级
export const districtTreeSearch = p =>
  _vm.fetch(BASEURL + "/deviceDistrict/v2/device-districts-info", p, "GET");

// 全量获取整棵树
export const cityTreeAsync = p =>
  _vm.fetch(
    BASEURL +
    "/deviceDistrict/v2/tree-structure?deviceCode=33554688&ytStatus=20&putStatusCode=0",
    p,
    "GET"
  );

export const queryAreaList = p =>
  _vm.fetch(BASEURL + "/bp" + VERSION + "/queryDistList", p, "GET");

export const saveCertification = p =>
  _vm.fetch(
    BASEURL + "/customer_info" + VERSION + "/certification/save",
    p,
    "POST"
  );

export const getOrderContentCode = () =>
  _vm.fetch(
    BASEURL + "/bp" + VERSION + "/getDictItemList",
    { dictTypeCode: "ADVORDERCONTENR" },
    "GET"
  );

export const getOrderGraph = p => _vm.fetch(BASEURL + "/dmp" + VERSION + "/getOrderGraph", p, "POST")

// 按天
export const getOrderGraphDay = p =>
  _vm.fetch("/advert-data-warehouse/v1/order/data-lake/date-stat", p, "GET", {}, undefined, undefined, AbortSignal.timeout(60000))
// 按时段
export const getOrderGraphSegment = p =>
  _vm.fetch("/advert-data-warehouse/v1/order/data-lake/timeSegment-stat", p, "GET", {}, undefined, undefined, AbortSignal.timeout(60000))

// 新版智能快速excel投放搜索
export const getIntelligentDeviceByExcel = p =>
  _vm.fetch(
    BASEURL + "/deviceSlot" + VERSION + "/getIntelligentDeviceByExcel",
    p,
    "POST"
  );
export const getIntelligentDeviceByExcelOpt = p =>
  _vm.fetch(
    BASEURL + "/deviceSlot" + VERSION + "/getIntelligentDeviceByExcelOpt",
    p,
    "POST"
  );

// 新版智能快速查看小区接口(新增的分页接口)
export const getNbhdExcelByConditionPage = p =>
  _vm.fetch(
    BASEURL + "/deviceSlot" + VERSION + "/getNbhdExcelByConditionPage",
    p,
    "POST"
  );

// 新版智能快速投放小区excel导出
export const exportIntelligentNbhdExcel = p =>
  _vm.fetch(
    BASEURL + "/deviceSlot" + VERSION + "/exportIntelligentNbhdExcel",
    p,
    "blob-post"
  );

// 订单支付
export const orderPayment = (orderId, p) =>
  _vm.fetch(
    DSPURL + "/web/order" + VERSION + "/order/" + orderId + "/receipt",
    p,
    "PUT"
  );

// WiFi广告
// 订单复投查找广告接口
export const getWifiPutByOrder = p =>
  _vm.fetch(
    BASEURL + "/deviceSlot/network" + VERSION + "/getNetworkPutByOrder",
    p,
    "POST"
  );
// 订单复投查看点位详情
export const getWifiPutDetail = p =>
  _vm.fetch(
    BASEURL + "/deviceSlot/network" + VERSION + "/getOrderNetworkPutDetails",
    p,
    "POST"
  );
// 订单复投导出点位详情
export const exportWifiReputDetail = p =>
  _vm.$export(
    BASEURL + "/deviceSlot/network" + VERSION + "/exportNetWorkOrderExcel",
    p
  );

// 监播服务-提交屏幕/摄像头截图任务
export const submitMonitTask = p => _vm.fetch("/track/web/monitor" + VERSION + "/createTask", p, "POST")

/**
 * 获取广告工具应用obs下载链接
 * @param {Object} p { name:应用名称(zladvutil), platform:平台系统(win32/mac) }
 */
export const lastVersionAdvUtil = p => _vm.fetch("/tool/appPkg/lastVersion", p, "GET")

/**** DSP模块  ****/
export const getOrderList = (p, noLoading) =>
  _vm.fetch(DSPURL + "/web/order" + VERSION + "/getOrderPage", p, "POST", {}, undefined, noLoading);

export const getReportOrderList = p =>
  _vm.fetch(
    DSPURL + "/web/order" + VERSION + "/getOrderContentUsePage",
    p,
    "POST"
  );

export const getOrderDetail = p =>
  _vm.fetch(DSPURL + "/web/order" + VERSION + "/getOrder", p, "GET");

export const getOrderDetailByCode = p =>
  _vm.fetch(DSPURL + "/web/order" + VERSION + "/getOrderByCode", p, "GET");

export const addOrderMaterial = p =>
  _vm.fetch(DSPURL + "/content" + VERSION + "/addContentMaterial", p, "POST");

export const getVideoNewsStatus = () =>
  _vm.fetch(DSPURL + "/web/order" + VERSION + "/getOrderContentTab", {}, "GET");

export const getOrderContent = p =>
  _vm.fetch(
    DSPURL + "/web/order" + VERSION + "/getOrderContentPage",
    p,
    "POST"
  );

// 我的订单-查看详情
export const getOrderPlayInfo = p =>
  _vm.fetch(DSPURL + "/web/order" + VERSION + "/getOrderPlayInfo", p, "GET");

//获取订单中购买小区播放的详情信息
export const getOrderNbhdPlayInfo = p =>
  _vm.fetch(
    DSPURL + "/web/order" + VERSION + "/getOrderNbhdPlayInfo",
    p,
    "GET"
  );

// 监播服务-获取订单日-小区设备详情  districtRequests=[{districtCode:*,levelNum:*}],guid=D1558074728720,targetDate=2019-05-19,targetTime=16:18
export const getOrderDailyInfo = p =>
  _vm.fetch(DSPURL + "/web/order" + VERSION + "/getOrderDailyInfo", p, "POST");

// 广告素材分类及累计投屏数
export const getOrderSum = p =>
  _vm.fetch(DSPURL + "/web/order" + VERSION + "/getHomeOrderSum", p, "get");

// Wifi广告
// 搜索订单
export const searchOrderCode = p =>
  _vm.fetch(DSPURL + "/web/order" + VERSION + "/searchOrderCode", p, "GET");
// 下单接口
export const saveOrderDeviceWiFiScreen = p =>
  _vm.fetch(
    DSPURL + "/web/order" + VERSION + "/saveOrderDeviceWiFiScreen",
    p,
    "POST"
  );

// 生成关注度对比报告任务
export const attentionTask = p => _vm.fetch(FREPORT + "/order" + VERSION + "/attention/task", p, "PUT")
// 对比报告任务分页
export const attentionTaskPage = p => _vm.fetch(FREPORT + "/order" + VERSION + "/attention/task/page", p, "GET")
// 删除对比报告任务
export const attentionTaskDelete = id => _vm.fetch(FREPORT + "/order" + VERSION + "/attention/task/" + id, undefined, "DELETE")

// 订单分页新版接口
export const orderPage = p => _vm.fetch('/order2/api/v1/order/page', p, 'GET')
